<template>
  <div
    class="py-4 container-fluid min-vh-100 media-page"
    :class="{ 'media-page-dark': isDarkMode }"
  >
    <div class="media-hero mb-3">
      <h1>Média</h1>
      <p>Moje reels pro každého, kdo chce poznat INGA.</p>
    </div>

    <div class="row media-layout">
      <div class="col-12 col-lg-4 col-xl-3 mb-4">
        <div class="media-list">
          <button
            v-for="item in videos"
            :key="item.id"
            type="button"
            class="media-list-item"
            :class="{ 'is-active': activeId === item.id }"
            @click="selectVideo(item.id)"
          >
            <fa-icon class="media-list-icon" icon="fa-solid fa-circle-play" />
            <span class="media-list-text">
              <span class="media-list-title">{{ item.title }}</span>
              <span class="media-list-sub">{{ item.text }}</span>
            </span>
          </button>
        </div>
      </div>

      <div class="col-12 col-lg-8 col-xl-9 mb-4">
        <div class="media-player-card">
          <div class="media-player-head">
            <h2 class="media-player-title">{{ active.title }}</h2>
            <p class="media-player-lead">{{ active.text }}</p>
          </div>
          <div class="media-stage">
            <video
              ref="videoRef"
              :key="active.id"
              class="media-video"
              controls
              playsinline
              preload="metadata"
            >
              <source :src="active.file" type="video/mp4" />
              Video v tomto prohlížeči nepřehraju.
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, nextTick, ref, watch } from "vue";
import { useStore } from "vuex";

const store = useStore();
const isDarkMode = computed(() => !!store.state.isDarkMode);

const videos = [
  {
    id: "inga",
    title: "INGA",
    text: "Krátké představení.",
    file: "/video/inga.mp4"
  },
  {
    id: "inga-music",
    title: "INGA Music",
    text: "Mám pro tebe spoustu music výher.",
    file: "/video/inga_music.mp4"
  },
  {
    id: "inga-music-2",
    title: "INGA Music",
    text: "Ještě jedna music výhra — bav se.",
    file: "/video/inga_music_2.mp4"
  },
  {
    id: "inga-coffee",
    title: "INGA Coffee",
    text: "Každý správný investor občas potřebuje kafčo.",
    file: "/video/inga_coffee.mp4"
  }
];

const activeId = ref(videos[0].id);
const active = computed(() => videos.find((item) => item.id === activeId.value) || videos[0]);
const videoRef = ref(null);

function playActiveVideo() {
  nextTick(() => {
    const el = videoRef.value;
    if (!el) return;
    el.play().catch(() => {});
  });
}

function selectVideo(id) {
  if (activeId.value === id) {
    const el = videoRef.value;
    if (el) {
      el.currentTime = 0;
      el.play().catch(() => {});
    }
    return;
  }
  activeId.value = id;
}

watch(activeId, () => {
  playActiveVideo();
});
</script>

<style scoped>
.media-page {
  background: #FFF7ED;
}

.media-page-dark {
  background: #1E293B !important;
}

.media-hero {
  border-radius: 0.65rem;
  padding: 1.15rem 1.35rem;
  background: #ffffff;
  border: 1px solid #e5e5e7;
}

.media-page-dark .media-hero {
  background: #0F172A !important;
  border: 1px solid #334155 !important;
}

.media-hero h1 {
  margin: 0;
  font-weight: 800;
  font-size: 1.5rem;
  letter-spacing: -0.02em;
  color: #0F172A;
}

.media-page-dark .media-hero h1 {
  color: #FF8A4C !important;
}

.media-hero p {
  margin: 0.35rem 0 0;
  color: #64748B;
}

.media-page-dark .media-hero p {
  color: #CBD5E1 !important;
}

.media-list {
  background: #ffffff;
  border: 1px solid #e5e5e7;
  border-radius: 0.65rem;
  padding: 0.5rem;
}

.media-page-dark .media-list {
  background: #0F172A;
  border-color: #334155;
}

.media-list-item {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  text-align: left;
  border: 0;
  background: transparent;
  border-radius: 0.55rem;
  padding: 0.75rem 0.85rem;
  cursor: pointer;
  color: inherit;
}

.media-list-item:hover,
.media-list-item.is-active {
  background: rgba(255, 138, 76, 0.12);
}

.media-list-icon {
  margin-top: 0.15rem;
  color: #FF8A4C;
}

.media-list-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.media-list-title {
  font-weight: 800;
  font-size: 0.95rem;
  color: #0F172A;
}

.media-page-dark .media-list-title {
  color: #E2E8F0;
}

.media-list-sub {
  font-size: 0.78rem;
  color: #64748B;
}

.media-page-dark .media-list-sub {
  color: #94A3B8;
}

.media-layout {
  align-items: flex-start;
}

.media-player-card {
  background: #ffffff;
  border: 1px solid #e5e5e7;
  border-radius: 0.65rem;
  padding: 0.85rem 1rem 1rem;
}

.media-page-dark .media-player-card {
  background: #0F172A;
  border-color: #334155;
}

.media-player-head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem 0.85rem;
  margin-bottom: 0.65rem;
}

.media-player-title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 800;
  color: #0F172A;
  flex-shrink: 0;
}

.media-page-dark .media-player-title {
  color: #E2E8F0;
}

.media-player-lead {
  margin: 0;
  color: #64748B;
  font-size: 0.9rem;
  flex: 1;
  min-width: 10rem;
}

.media-page-dark .media-player-lead {
  color: #CBD5E1;
}

.media-stage {
  background: #0F172A;
  border-radius: 0.75rem;
  overflow: hidden;
}

.media-video {
  display: block;
  width: 100%;
  max-height: min(70vh, 720px);
  background: #000;
}

@media (max-width: 430px) {
  .media-player-lead {
    min-width: 0;
    font-size: 0.82rem;
  }

  .media-player-title {
    font-size: 1rem;
  }
}
</style>
